import { render, staticRenderFns } from "./ArticleLiveBlogHeader.vue?vue&type=template&id=1ef63a7c&scoped=true"
import script from "./ArticleLiveBlogHeader.vue?vue&type=script&lang=ts"
export * from "./ArticleLiveBlogHeader.vue?vue&type=script&lang=ts"
import style0 from "./ArticleLiveBlogHeader.vue?vue&type=style&index=0&id=1ef63a7c&prod&lang=scss&scoped=true"
import style1 from "./ArticleLiveBlogHeader.vue?vue&type=style&index=1&id=1ef63a7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef63a7c",
  null
  
)

export default component.exports